const AboutSection = () => {
  const features = [
    'Future-Ready IT Solutions',
    'Technology That Works for You',
    'Smart Solutions, Real Results',
    'Engineering Digital Excellence',
  ];

  const stats = [
    { value: '20+', label: 'Years of Experience' },
    { value: '30+', label: 'Happy Clients' },
    { value: '50+', label: 'Projects Completed' },
    { value: '80+', label: 'Recognitions Over Two Decades' },
  ];

  return (
    <section id="about" className="relative w-full bg-background-50 border-t border-background-200 py-14 md:py-16">
      <div className="section-padding">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="inline-flex w-6 h-6 items-center justify-center bg-foreground-900 text-background-50 rounded-sm">
                  <i className="ri-information-line text-xs"></i>
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground-600">
                  01 / About Us
                </span>
              </div>

              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.02] tracking-tight text-foreground-900 max-w-3xl">
                Crafting the Future of{' '}
                <span className="block text-primary-500">Digital Innovation.</span>
              </h2>

              <p className="mt-6 text-[15px] leading-relaxed text-foreground-700 max-w-md">
                We are a forward-thinking IT company delivering reliable, scalable, and secure digital solutions for modern businesses. Our expertise spans software development, web and mobile applications, cloud solutions, and enterprise technology services.
              </p>

              <div className="mt-8 space-y-3">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-6 h-6 rounded-full bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-primary-500 text-sm"></i>
                    </div>
                    <span className="text-foreground-800 font-medium text-sm">{feature}</span>
                  </div>
                ))}
              </div>

              <a
                href="#contact"
                className="mt-8 inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-background-50 px-6 py-3 rounded-full text-sm font-semibold transition-colors whitespace-nowrap"
              >
                Learn More About Us
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
            </div>

            <div className="grid grid-cols-2 gap-4 md:gap-6">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className={`bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200 transition-all duration-500 hover:-translate-y-1 ${index % 2 === 1 ? 'md:mt-8' : ''}`}
                >
                  <div className="w-12 h-12 bg-foreground-900 rounded-xl flex items-center justify-center mb-4">
                    <i className={`ri-${['calendar-line', 'user-smile-line', 'briefcase-line', 'trophy-line'][index]} text-background-50 text-xl`}></i>
                  </div>
                  <div className="text-3xl md:text-4xl font-bold text-foreground-900 font-display mb-2">
                    {stat.value}
                  </div>
                  <div className="text-foreground-500 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;